import {recordEvent} from 'js/ts/tracking'

export default class SearchTracking {

  constructor() {
    this.attachSearchTracking()
  }

  private attachSearchTracking(): void {
    $("#global-search-form").on("submit", function (e) {
        const trackingVariables = {
            eVar12: s.prop9, // Logged In Status
            prop9: s.prop9, // Logged In Status
        }
        recordEvent("event1", trackingVariables)
    });
  }
}